import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { ref } from '@vue/composition-api';
// 获取客户端位置信息
function getGeoPosition() {
  return _getGeoPosition.apply(this, arguments);
} // 获取系统音量
function _getGeoPosition() {
  _getGeoPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var geoData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            geoData = ref({});
            if (!navigator.geolocation) {
              _context2.next = 6;
              break;
            }
            navigator.geolocation.getCurrentPosition(function (position) {
              var latitude = position.coords.latitude;
              var longitude = position.coords.longitude;
              geoData.value = {
                latitude: latitude,
                longitude: longitude
              };
              // 可以在这里使用获取到的经纬度进行其他操作，比如调用地图 API 展示位置等
            }, function (error) {
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  console.log("User denied the request for Geolocation.");
                  break;
                case error.POSITION_UNAVAILABLE:
                  console.log("Location information is unavailable.");
                  break;
                case error.TIMEOUT:
                  console.log("The request to get user location timed out.");
                  break;
              }
            });
            return _context2.abrupt("return", geoData);
          case 6:
            console.log("Geolocation is not supported by this browser.");
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getGeoPosition.apply(this, arguments);
}
function getVolume() {
  // 获取系统音量
  var volumeData = 0;
  // 检测浏览器是否支持Web Audio API
  if (window.AudioContext) {
    // 创建一个新的AudioContext对象
    var context = new AudioContext();
    // 创建一个GainNode，用以获取系统音量
    var gainNode = context.createGain();
    // 将GainNode连接到主输出（你的扬声器）
    gainNode.connect(context.destination);
    // 获取系统音量
    var systemVolume = gainNode.gain.value;
    // 打印系统音量
    console.log('系统音量:', systemVolume);
    volumeData = systemVolume;
  } else {
    console.error('你的浏览器不支持Web Audio API');
  }
  return volumeData;
}
// 获取浏览器安装插件
function getInstalledPlugins() {
  return _getInstalledPlugins.apply(this, arguments);
}
function _getInstalledPlugins() {
  _getInstalledPlugins = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var plugins;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            plugins = ref([]);
            if (!navigator.plugins) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", plugins);
          case 5:
            console.log('当前浏览器不支持获取插件信息。');
          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getInstalledPlugins.apply(this, arguments);
}
function getIPAddress(_x) {
  return _getIPAddress.apply(this, arguments);
}
function _getIPAddress() {
  _getIPAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(devicesInfo) {
    var ip, connection, offer;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // 获取ip地址
            ip = '';
            _context4.prev = 1;
            connection = new RTCPeerConnection({
              iceServers: []
            }); // 创建一个RTCPeerConnection对象
            connection.createDataChannel(''); // 创建一个数据通道
            _context4.next = 6;
            return connection.createOffer();
          case 6:
            offer = _context4.sent;
            _context4.next = 9;
            return connection.setLocalDescription(offer);
          case 9:
            connection.onicecandidate = function (event) {
              if (event.candidate) {
                var _ipRegex$exec;
                var ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/; // IP地址的正则表达式
                var ipAddress = (_ipRegex$exec = ipRegex.exec(event.candidate.candidate)) === null || _ipRegex$exec === void 0 ? void 0 : _ipRegex$exec[1]; // 从ICECandidate中提取IP地址
                ip = ipAddress || '';
                devicesInfo.value.ip = ipAddress;
                connection.close(); // 关闭连接
                return ip;
              }
            };
            _context4.next = 15;
            break;
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](1);
            console.error('无法获取IP地址', _context4.t0);
          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 12]]);
  }));
  return _getIPAddress.apply(this, arguments);
}
export function useGetDevicesInfo() {
  var devicesInfo = ref({});
  var getDevicesInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _window, _window2, _window$screen, _window3, _navigator2;
      var _navigator, resolution, screenSize;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                navigator.getBattery().then(function (battery) {
                  devicesInfo.value.battery = battery === null || battery === void 0 ? void 0 : battery.level;
                });
              } catch (error) {
                console.error('无法获取设备电量信息', error);
              }
              // 获取系统版本号
              try {
                devicesInfo.value.systemVersion = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent;
              } catch (error) {
                console.error('无法获取系统版本号', error);
              }
              // // 获取ip地址
              // devicesInfo.value.ip = await getIPAddress()
              // 获取设备分辨率信息
              resolution = ((_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) + "x" + ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerHeight);
              devicesInfo.value.resolution = resolution || '';
              // 获取设备屏幕大小
              screenSize = ((_window$screen = window.screen) === null || _window$screen === void 0 ? void 0 : _window$screen.width) + "x" + ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.screen.height);
              devicesInfo.value.screenSize = screenSize || '';
              // 获取设备分辨率信息
              // 获取系统语言
              devicesInfo.value.language = (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.language;
              // 获取设备音量信息
              try {
                devicesInfo.value.volume = getVolume();
              } catch (error) {
                console.error('无法获取设备音量信息', error);
              }
              // devicesInfo.value.volume = getVolume()
              // 获取设备网络类型
              // 获取ip地址
              // getIPAddress(devicesInfo);
              // 获取设备安装的插件
              _context.prev = 8;
              _context.next = 11;
              return getInstalledPlugins();
            case 11:
              devicesInfo.value.plugins = _context.sent;
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](8);
              console.error('无法获取设备安装的插件', _context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 14]]);
    }));
    return function getDevicesInfo() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    devicesInfo: devicesInfo,
    getDevicesInfo: getDevicesInfo
  };
}